import { metrics } from '@seek/metrics-js';
import { useTranslations } from '@vocab/react';
import { Alert, Text, TextLinkButton } from 'braid-design-system';
import React from 'react';

import { useRetryActionStore } from 'src/modules/retry-actions/RetryActionProvider';
import { useRetryAction } from 'src/modules/retry-actions/hooks';
import type { Card } from 'src/types';

import translations from './.vocab';

interface NewCardErrorProps {
  card: Card;
}

export const CardError = ({ card }: NewCardErrorProps) => {
  const { t } = useTranslations(translations);
  const retryAction = useRetryAction(card);
  const { dispatch } = useRetryActionStore();

  const onRetry = () => {
    metrics.count('card-error-retry', [`id:${card}`]);
    dispatch({ type: 'setCanRetry', payload: { key: card, canRetry: false } });
  };

  const onRetryClick = () => {
    onRetry?.();
    retryAction?.action?.();
  };

  return (
    <Alert tone="critical" data={{ automation: `${card}-card-error` }}>
      <Text>
        {t('Sorry, we have an issue on our end.')}
        {retryAction && (
          <>
            {' '}
            {t('Try again later', {
              TextLinkButton: (v) => (
                <TextLinkButton
                  data={{ automation: 'retry-action' }}
                  onClick={onRetryClick}
                  hitArea="large"
                >
                  {v}
                </TextLinkButton>
              ),
            })}
          </>
        )}
      </Text>
    </Alert>
  );
};
